/**
 * This file is the entry to load themes. Previously it only re-exported Eneco.
 * Export a themes map so runtime can switch between eneco, oxxio, and woonenergie.
 */
import { themes as enecoThemes, globalStyles, iconSizes } from './eneco';
import { themes as oxxioThemes } from './oxxio';
import { themes as woonenergieThemes } from './woonenergie';

// Maintain a default for backwards compatibility (Eneco)
export const themes = {
  eneco: enecoThemes.default,
  oxxio: oxxioThemes.default,
  woonenergie: woonenergieThemes.default,
  default: enecoThemes.default,
};

// Backwards compatibility: some vanilla-extract helpers import `{ theme }` from here
// Provide `theme` as the default (Eneco) theme tokens
export const theme = themes.default;

export { globalStyles, iconSizes };
